$(document).ready(function () {
  const productRel = $(".product .product__title h1").attr("rel");

  function getWorldTime(tzOffset) {
    var now = new Date();
    var tz =
      now.getTime() + now.getTimezoneOffset() * 60000 + tzOffset * 3600000;

    now.setTime(tz);

    return (
      leadingZeros(now.getFullYear(), 4) +
      "-" +
      leadingZeros(now.getMonth() + 1, 2) +
      "-" +
      leadingZeros(now.getDate(), 2) +
      " " +
      leadingZeros(now.getHours(), 2) +
      ":" +
      leadingZeros(now.getMinutes(), 2) +
      ":" +
      leadingZeros(now.getSeconds(), 2)
    );
  }

  function leadingZeros(n, digits) {
    var zero = "";
    n = n.toString();

    if (n.length < digits) {
      for (var i = 0; i < digits - n.length; i++) {
        zero += "0";
      }
    }

    return zero + n;
  }

  /* 워시필, 글리실 제품 최상단 배너 추가 */
  const rel = $('#new_product .product__title h1').attr('rel');

  if (['9793720975649', '8221579477281'].includes(rel)) {
      $('.product__description p').prepend(
          '<img src="https://cdn.shopify.com/s/files/1/0746/2164/9185/files/2915b2c8d9bb4f28b9dfb087b1daead0.jpg?v=1785823641" alt="prmBnr">'
      );
  }
  /* [E] 워시필, 글리실 제품 최상단 배너 추가 */
  

  const currentTime = getWorldTime(9);
  const isPreview = window.location.href.includes("preview=true");

  var promotionEvent = (currentTime >= "2026-07-20 00:00:00" && currentTime <= "2026-07-31 23:59:59") || isPreview;
  if (promotionEvent) {
    // 메인 슬라이드
    if ($(".main_slide").length > 0) {
        $(".main_slide .swiper-slide.glycineBnr").remove();
        $(".main_slide .swiper-slide.prmBnr").show();
        $(".main_slide .swiper-slide.prmBnr .promotion_t01").css('letter-spacing','-0.5px');
    }

    // // 상세페이지 변경 (트리플세트 제품 한정)
    if ($('.product__title h1[rel="10425741869345"]').length) {
        const img = $('.gallery-top .swiper-slide:first .product__media img');

        img.attr({
            src: 'https://cdn.shopify.com/s/files/1/0746/2164/9185/files/5cb0e619b9958e56e818c36639a1f79e_02800190-b221-49d0-abea-e40c2a3112f1.jpg?v=1784081740',
            srcset: '',
        });

        $('.product_detail_wrap .product__description p').prepend('<div class="imgWrap" style="position: relative;"><a href="/account/login" class="link1" style="position: absolute;display: block;bottom: 12.8%;left: 50%;width: 50%;height: 3%;transform: translateX(-50%);"></a><a href="https://lin.ee/9mqZ0ni" class="link2" style="position: absolute;display: block;bottom: 6.5%;left: 50%;width: 50%;height: 3%;transform: translateX(-50%);"></a><img src="https://cdn.shopify.com/s/files/1/0746/2164/9185/files/9a8349de4d0c51c698abc4a8b59819ae.jpg?v=1784081949"></div>');
    }

  }else{
    $(".main_slide .swiper-slide.prmBnr").remove();
  }

});